import React from 'react';
import PropTypes from 'prop-types';


const IconExpand = ({ width = '14px', height = '12px' }) => {
    return <svg width={width} height={height} viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8.5 0.5L14 6L8.5 11.5L7 10L11 6L7 2L8.5 0.5ZM1.5 0.5L7 6L1.5 11.5L0 10L4 6L0 2L1.5 0.5Z' fill='#1F1F1F' />
    </svg>;

};

IconExpand.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IconExpand;
